import { render, staticRenderFns } from "./AudioControl.vue?vue&type=template&id=7063bbd6&scoped=true&"
import script from "./AudioControl.vue?vue&type=script&lang=js&"
export * from "./AudioControl.vue?vue&type=script&lang=js&"
import style0 from "./AudioControl.vue?vue&type=style&index=0&id=7063bbd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7063bbd6",
  null
  
)

export default component.exports